import script from "./Responses.vue?vue&type=script&setup=true&lang=ts"
export * from "./Responses.vue?vue&type=script&setup=true&lang=ts"

import "./Responses.vue?vue&type=style&index=0&id=2fcc25c5&lang=css"

const __exports__ = script;

export default __exports__